import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import Reveal from "./Reveal";

const faqs = [
  {
    q: "Vad hjälper Svea Ytservice med?",
    a: "Svea Ytservice hjälper kunder med skonsam ytservice kopplat till tak, fasad och utsatta ytor. Fokus ligger på noggrant utfört arbete, rätt metod och tydlig återkoppling.",
  },
  {
    q: "Varför är skonsamma metoder viktiga?",
    a: "För hårda metoder kan riskera att skada tak och fasad. Därför arbetar Svea Ytservice varsamt och rekommenderar lösningar som hjälper ytorna att hålla sig i gott skick längre.",
  },
  {
    q: "Kan ni kontrollera tak och fasad innan arbetet?",
    a: "Ja, Svea Ytservice går igenom förutsättningarna före arbetet och kontrollerar även efteråt för att kunna rekommendera rätt åtgärd.",
  },
  {
    q: "Hur skickar jag en förfrågan?",
    a: "Fyll i formuläret med namn, kontaktuppgift och en kort beskrivning av vad du behöver hjälp med, så återkommer Svea Ytservice så snart de kan.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="section-faq"
      className="bg-[#F7F5F0] py-24 md:py-32"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <Reveal className="lg:col-span-5">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#1A362B]/70">
              FAQ
            </div>
            <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1F2321] text-balance">
              Vanliga <span className="text-[#1A362B]">frågor</span>
            </h2>
            <p className="mt-5 text-[#5C6B64] leading-relaxed">
              Korta svar på det som många undrar. Hittar du inte det du söker —
              skriv ett par rader i formuläret nedan.
            </p>
          </Reveal>

          <Reveal className="lg:col-span-7">
            <Accordion
              type="single"
              collapsible
              className="w-full bg-white border border-[#E2DCD0] rounded-2xl overflow-hidden"
              data-testid="faq-accordion"
            >
              {faqs.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i + 1}`}
                  className="border-b border-[#E2DCD0] last:border-b-0 px-5 md:px-7"
                >
                  <AccordionTrigger className="text-left font-serif-display text-base md:text-lg text-[#1F2321] py-5 md:py-6 hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#5C6B64] text-[15px] leading-relaxed pb-5 md:pb-6 pr-2">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
